module.exports = __webpack_public_path__ + "static/media/ClubMembersImage5.477b635e.jpg";